/**
 * Small builders shared by the fal descriptor files (plan section 2).
 *
 * PURE: `import type` only. Importable from server/ and src/.
 */
import type { MediaWire, Port } from './types';

/** The single start/reference image port. `handle` defaults to the legacy node's input handle id. */
export const IMG = (handle = 'input-image'): Port => ({ slot: 'image', kind: 'image', min: 1, max: 1, handle });

/** The last-frame port of a first-last-frame mode. */
export const END = (): Port => ({ slot: 'endImage', kind: 'image', min: 1, max: 1, handle: 'input-image-last' });

/** `image_url`, materialized with the per-surface image encoder. */
export const W_IMG: MediaWire = { field: 'image_url', encode: 'image' };

/** `end_image_url`, materialized with the per-surface image encoder. */
export const W_END: MediaWire = { field: 'end_image_url', encode: 'image' };

/**
 * fal's `image_size` preset enum, keyed by the Knods aspect ratio.
 * Equal to falai.ts:57-63 and ProviderService.ts:283-291 (descriptorConformance pins the copy).
 */
export const FAL_IMAGE_SIZE_PRESETS: Readonly<Record<string, string>> = {
  '1:1': 'square_hd',
  '9:16': 'portrait_16_9',
  '16:9': 'landscape_16_9',
  '4:3': 'landscape_4_3',
  '3:4': 'portrait_4_3',
};
